import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import DataWrapper from '../../../principal/containers/DataWrapper';
import SailingBreakdownStore from "../stores/SailingBreakdownStore";
import Footer from "../../../comum/components/Footer";
import { TabelaSailingBreakdown } from "../components/TabelaSailingBreakdown";
import { FiltrosSailingBreakdown } from "../components/FiltrosSailingBreakdown"
import { Container } from "reactstrap";
import FooterContent from '../../../comum/components/FooterContent';


import { Row, Col, InputGroup, Label, Button } from "reactstrap";

@inject("store")
@DataWrapper
@observer
export class SailingBreakdown extends Component {

    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;

        this.controller = new SailingBreakdownStore();
    }

    componentWillMount() {
        this.logging = false;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Sailing Breakdown");
        this.appStore.showTopbar(true);
    }


    render() {
        return (
            <div>
                <div className="form-wrapper">
                    <Container fluid>
                        <FiltrosSailingBreakdown controller={this.controller} />
                        <TabelaSailingBreakdown controller={this.controller} />
                    </Container>
                </div>
                <Footer>
                    <FooterContent>
                        {this.controller.total !== null &&
                            <div className="justify-content-between">
                                <div>
                                    <b>{this.controller.itens.length}</b> {this.controller.total === 1 ? 'registro' : 'registros'} -
                                <a onClick={() => this.controller.pesquisar()}>Atualizar Lista</a>
                                </div>
                            </div>
                        }
                    </FooterContent>
                </Footer>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/consultas/sailing-breakdown/tela/SailingBreakdown.js